import React from 'react';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import RsTableToolbarButton from '@Pages/RetroSynthesis/components/RsTableToolbarButton';

const ConditionsButton = ({ conditionsIsShown, setConditionsIsShown, routeType }) => {
  const onClickHandler = () => {
    setConditionsIsShown(!conditionsIsShown);
  };

  const label = routeType === RouteType.PREDICTED ? 'Reaxys Examples' : 'conditions';

  return (
    <RsTableToolbarButton
      icon={conditionsIsShown ? 'eye-hide' : 'eye'}
      label={conditionsIsShown ? `Hide ${label}` : `Show ${label}`}
      onClick={onClickHandler}
    />
  );
};

export default ConditionsButton;
